export function disableDeletePageRules(currentPage, pagesAllIds) {
  const {
    isCover,
    isBabyPage,
  } = currentPage;

  // Can't delete first page, cover page and baby page
  if (pagesAllIds.length > 1 && !isCover && !isBabyPage) {
    return true;
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/helpers/deletePage.js